<template>
  <label
    for="input-checkbox"
    class="checkbox-toggle"
    :class="{ disabled: isDisabled, 'bg-bgDark': checked, 'bg-bgDefault': !checked }"
  >
    <slot name="prepend" />
    <input
      id="input-checkbox"
      v-model="checked"
      type="checkbox"
    />
    <span class="text-textDarkest">{{ disabledText || labelText }}</span>
    <slot name="append" />
  </label>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  checkedLabel: {
    type: String,
    default: '',
  },
  uncheckedLabel: {
    type: String,
    default: '',
  },
  useDisabledLabel: {
    type: Boolean,
    default: false,
  },
  disabledLabel: {
    type: String,
    default: '',
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
  modelValue: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:model-value']);

const checked = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:model-value', value),
});

const labelText = computed(() => (checked.value ? props.checkedLabel : props.uncheckedLabel));

const disabledText = computed(() => (props.useDisabledLabel && props.disabledLabel ? props.disabledLabel : ''));
</script>

<style lang="less" scoped>
.checkbox-toggle {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: 1px solid @stroke-default;
  padding: 7px;
  border-radius: 8px;
  gap: 2px;

  &.disabled {
    pointer-events: none;
    filter: opacity(0.5);
  }

  &:hover {
    cursor: pointer;
  }

  span {
    font-size: 13px;
    font-weight: 500;
  }

  input {
    visibility: hidden;
    width: 0;
  }

  :deep(.v-icon) path {
    fill: rgb(var(--v-theme-iconDefault));
  }
}
</style>
